module.exports = __webpack_public_path__ + "static/media/Magri.fb869503.png";